import React from 'react';
import { useDiscoveryExit } from '../../../hooks/useDiscoveryExit';
import { PickerComponent } from '../../../hooks/useCreditsPicker';
import ConnectedCreditsPicker from './ConnectedCreditsPicker';
import ConnectedDiscoveryRefused from './ConnectedDiscoveryRefused';

/**
 * What Step 2 shows when Continue could not pay for discovery: the refused
 * card in place when the balance covers no line, the picker when it covers
 * some. Renders nothing otherwise.
 */
export interface DiscoveryCreditsProps {
  exit: ReturnType<typeof useDiscoveryExit>;
  components: PickerComponent[];
  /** Display RFQ id for the credit request, e.g. RFQ-003. */
  rfqLabel?: string;
}

export const DiscoveryCredits: React.FC<DiscoveryCreditsProps> = ({ exit, components, rfqLabel }) => (
  <>
    {exit.refused && <ConnectedDiscoveryRefused refusal={exit.refused} rfqLabel={rfqLabel} />}
    {/* Mounted only while open: the refused case needs no hidden modal. */}
    {exit.pickerOpen && exit.refusal && (
      <ConnectedCreditsPicker
        open
        refusal={exit.refusal}
        components={components}
        rfqLabel={rfqLabel}
        starting={exit.starting}
        error={exit.pickerError}
        onStart={exit.startSelected}
        onCancel={exit.cancelPicker}
      />
    )}
  </>
);

export default DiscoveryCredits;
